import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogComponent,
  AutocompleteComponent,
  Spinner
} from '../../../Components';
import { showError, showSuccess } from '../../../Helper';
import { AssignLeadAuditorToAgents } from '../../../Services';

export const OpenAssignDialog = ({
  isOpen,
  setIsOpenAssignDialog,
  data,
  checkedCardsIds,
  reloadPage,
  parentTranslationPath,
  translationPath,
  searchHandler,
  isLoading,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [selectedLeadAuditor, setSelectedLeadAuditor] = useState(null);
  const [reSaleLeadAuditorId, setreSaleLeadAuditorId] = useState(null);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [isSaveIsDisabled, setIsSaveIsDisabled] = useState(true);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const confirmReassignment = useCallback(async () => {
    setIsLoadingSave(true);
    const body = {
      leadAuditorId: selectedLeadAuditor?.leadAuditorId,
      reSaleLeadAuditorId: reSaleLeadAuditorId?.leadAuditorId,
      agentsIds: checkedCardsIds
    };

    const res = await AssignLeadAuditorToAgents(body);

    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t(`${translationPath}assign-to-lead-owner-Successfully`));
       reloadPage(); 
    } else {
      showError(t(`${translationPath}faild-to-assign-to-lead-owner`));
    }

    setIsOpenAssignDialog(false);
    setIsLoadingSave(false);
    setIsConfirmationOpen(false);
  }, [checkedCardsIds, reSaleLeadAuditorId, selectedLeadAuditor, t, translationPath, setIsOpenAssignDialog]);

  return (
    <>
      <Spinner isActive={isLoadingSave} />
      <DialogComponent
        isOpen={isOpen}
        titleText='assign-to-lead-owner'
        maxWidth='sm'
        onSaveClicked={(e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          setIsConfirmationOpen(true);
        }}
        saveText='Confirm'
        onCancelClicked={() => setIsOpenAssignDialog(false)}
        saveIsDisabled={isLoading || isSaveIsDisabled}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        dialogContent={(
          <>
            <div className='side-menu-actions'>
              <div className='d-flex-center'>
                <span className='mx-2 mb-2 fz-16px fw-bold'>
                  {t(`${translationPath}Assign-lead-instructions`)}
                </span>
              </div>
            </div>
            <AutocompleteComponent
              idRef='LeadAuditorRef'
              multiple={false}
              data={(data?.result || []).filter((item) => item.isPrimary)}
              chipsLabel={(option) => option.leadAuditorName || ''}
              displayLabel={(option) => option.leadAuditorName || ''}
              onInputKeyUp={searchHandler}
              withoutSearchButton
              labelValue='Owner-Lead-Primary'
              inputPlaceholder='Owner-Lead-Primary-Select'
              isLoading={isLoading}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(e, newValue) => {
                setSelectedLeadAuditor(newValue);
                setIsSaveIsDisabled(false);
              }}
            />
            <div className='mt-2'>
              <AutocompleteComponent
                idRef='ResaleAuditorSearchAuditorRef'
                multiple={false}
                data={(data?.result || []).filter((item) => item.isResale)}
                chipsLabel={(option) => option.leadAuditorName || ''}
                displayLabel={(option) => option.leadAuditorName || ''}
                onInputKeyUp={searchHandler}
                withoutSearchButton
                labelValue='Owner-Lead-Resale'
                inputPlaceholder='Owner-Lead-Resale-Select'
                isLoading={isLoading}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                onChange={(e, newValue) => {
                  setreSaleLeadAuditorId(newValue);
                  setIsSaveIsDisabled(false);
                }}
              />
            </div>
          </>
        )}
      />

      <DialogComponent
        isOpen={isConfirmationOpen}
        titleText='confirm-reassignment'
        maxWidth='xs'
        dialogContent={(
          <div className='d-flex-center'>
            <span className='fz-16px'>
              {t(`${translationPath}are-you-sure-you-want-to-reassign-these-agents`)}
            </span>
          </div>
        )}
        saveText='Yes'
        cancelText='No'
        onCancelClicked={() => setIsConfirmationOpen(false)}
        onSaveClicked={(e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          confirmReassignment();
        }}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
      />
    </>
  );
};
